export default {
  resetBuildingState: (state) => {
    state.building_id = null;
    state.name = null;
    state.address = null;
    state.comments = null;
  },
  setBuildingData: (state, { building_id, name, address, comments }) => {
    state.building_id = building_id;
    state.name = name;
    state.address = address;
    state.comments = comments;
  },
  updateBuildingName: (state, name) => (state.name = name || null),
  updateBuildingAddress: (state, address) => (state.address = address || null),
  updateBuildingComment: (state, comments) =>
    (state.comments = comments || null),
};
